import { render, staticRenderFns } from "./DocumentTextBook.vue?vue&type=template&id=abca2a36&scoped=true"
import script from "./DocumentTextBook.vue?vue&type=script&lang=js"
export * from "./DocumentTextBook.vue?vue&type=script&lang=js"
import style0 from "./DocumentTextBook.vue?vue&type=style&index=0&id=abca2a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abca2a36",
  null
  
)

export default component.exports